// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommunicationPhone_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.49131 2L2.9999 2C2.71691 2 2.48002 2.11489 2.32885 2.27117C2.18643 2.4184 2.12519 2.59095 2.14587 2.78494C3.26461 13.2805 10.7194 20.7353 21.215 21.854C21.409 21.8747 21.5815 21.8135 21.7287 21.671C21.885 21.5199 21.9999 21.283 21.9999 21L21.9999 17.5086L17.3126 16.1694L15.8341 17.1059C14.936 17.6747 13.7493 17.7512 12.7561 17.1719C10.0805 15.6116 8.34873 13.6127 6.90319 11.3199C6.27642 10.3257 6.31077 9.0866 6.91243 8.13674L7.83053 6.68728L6.49131 2ZM7.99991 0L2.9999 0C1.34304 0 -0.0184794 1.3494 0.157133 2.99692C1.37573 14.4293 9.57062 22.6242 21.003 23.8428C22.6505 24.0184 23.9999 22.6568 23.9999 21L23.9999 16L16.9999 14L14.7639 15.4163C14.4599 15.6089 14.0744 15.6256 13.7636 15.4443C11.442 14.0903 9.923 12.3596 8.59504 10.2532C8.39344 9.93347 8.39973 9.52628 8.60201 9.20694L9.99991 7L7.99991 0Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.15817 2H3.00009C2.40345 2 2.08068 2.45719 2.11112 2.84225C3.30615 17.9578 14.0423 28.6939 29.1578 29.889C29.5429 29.9194 30.0001 29.5966 30.0001 29L30.0001 22.8419L23.0066 20.8438L20.2736 22.6658C19.3637 23.2724 18.1554 23.3547 17.1506 22.7807C13.5392 20.7175 11.2407 18.0477 9.29926 14.9309L10.9969 13.8735C12.8205 16.8012 14.9007 19.192 18.1427 21.0441C18.4624 21.2268 18.8579 21.2059 19.1642 21.0017L22.6667 18.6667L32.0001 21.3333L32.0001 29C32.0001 30.6568 30.6519 32.0133 29.0002 31.8827C12.9045 30.6102 1.38986 19.0956 0.117346 2.99987C-0.0132367 1.34817 1.34324 0 3.00009 0H10.6668L13.3334 9.33333L11.0178 12.8068C10.8034 13.1283 10.7925 13.5455 10.9969 13.8735L9.29926 14.9309C8.66997 13.9206 8.71445 12.6562 9.35369 11.6974L11.1563 8.99348L9.15817 2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommunicationPhone is a generated icon component.
 */
let IconCommunicationPhone = IconCommunicationPhone_1 = class IconCommunicationPhone extends IconBaseElement {
    render() {
        return html `${IconCommunicationPhone_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommunicationPhone.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommunicationPhone = IconCommunicationPhone_1 = __decorate([
    customElement('zui-icon-communication-phone')
], IconCommunicationPhone);
export { IconCommunicationPhone };
